import { Link } from "react-router-dom";
import { hotMovies } from "@/mocks/movies";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20cinema%20scene%2C%20abstract%20golden%20and%20amber%20light%20particles%20floating%20in%20a%20dark%20theater%20space%2C%20elegant%20curtain%20texture%2C%20warm%20cinematic%20glow%2C%20no%20text%2C%20no%20people%2C%20atmospheric%20and%20dramatic%2C%20rich%20dark%20brown%20and%20gold%20tones%2C%20professional%20cinematic%20composition&width=1920&height=900&seq=hero-bg-555&orientation=landscape"
        alt="555电影网 - 高清电影在线观看"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4">
          555电影网
        </h1>
        <p className="text-base md:text-xl text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          海量全集电影不缓冲秒播放 · 高清画质免费在线点播 · 无需下载即刻畅享流畅观影体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/action"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            立即观影
          </Link>
          <Link
            to="/category/scifi"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base border border-white/20"
          >
            热门推荐
          </Link>
        </div>

        <div className="mt-10 hidden md:flex items-center justify-center gap-8">
          {hotMovies.slice(0, 4).map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="flex items-center gap-2 text-white/70 hover:text-primary-300 transition-colors cursor-pointer group"
            >
              <span className="text-xs font-medium bg-white/15 px-2 py-0.5 rounded-full whitespace-nowrap">
                {movie.category}
              </span>
              <span className="text-sm whitespace-nowrap group-hover:underline">
                {movie.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}